import { ScheduleEventDeviceConfigType } from '@thingslog/repositories';
import { AutoRelaySwitchFactory } from './AutoRelaySwitchFactory';
import { EventConfigFactory } from './EventConfigFactory';
import { RelaySwitchFactory } from './RelaySwitchFactory';
import { SendDateOverMqttFactory } from './SendDateOverMqttFactory';
import { SingleRelaySwitchFactory } from './SingleRelaySwitchFactory';
import { TasmotaPowerFactory } from './TasmotaPowerFactory';
import { ScheduledRelayCommandFactory } from './ScheduledRelayCommandFactory';
import { ModbusReadCoilFactory } from './ModbusReadCoilFactory';
import { ModbusWriteCoilFactory } from './ModbusWriteCoilFactory';
import { ModbusReadRegisterFactory } from './ModbusReadRegisterFactory';
import { ScheduledRelayCommand4Factory } from './ScheduledRelayCommand4Factory';

export const scheduledEventFactory: Record<ScheduleEventDeviceConfigType, EventConfigFactory> = {
  SINGLE_RELAY_SWITCH: new SingleRelaySwitchFactory(),
  RELAY_SWITCH: new RelaySwitchFactory(),
  AUTO_RELAY_SWITCH: new AutoRelaySwitchFactory(),
  SEND_DATE_OVER_MQTT: new SendDateOverMqttFactory(),
  MODBUS_READ_REGISTER: new ModbusReadRegisterFactory(),
  MODBUS_WRITE_COIL: new ModbusWriteCoilFactory(),
  MODBUS_READ_COIL: new ModbusReadCoilFactory(),
  TASMOTA_POWER: new TasmotaPowerFactory(),
  SCHEDULED_RELAY_COMMAND: new ScheduledRelayCommandFactory(),
  SCHEDULED_RELAY_COMMAND_4: new ScheduledRelayCommand4Factory(),
};
